/**
 * Switches for parts of the UI we are trying life without.
 *
 * Not user preferences and not server configuration: one constant each, read
 * at build time, so turning a feature back on is a one-line change and a
 * deploy rather than a migration. That is the whole point — the DATA stays
 * where it is, and only the way in disappears.
 */

/**
 * Purposes — labels on an ACCOUNT, as against tags, which label a
 * transaction (ADR-0023's wallets cover most of what they were reached for).
 *
 * Hidden on 2026-10-04 to find out whether anyone misses them. Nothing is
 * deleted: `purpose` and `accountPurpose` keep their rows, their history and
 * their endpoints, so flipping this back shows exactly what was there.
 *
 * What it hides: the Purposes card in Settings, the purpose assignments on
 * the account editor, and the purpose filter on Reports. What it also has to
 * do, and the reason this is not simply three `hidden` attributes: a purpose
 * filter the reader chose BEFORE the switch is remembered in their
 * preferences, and a remembered filter with no control to show it would go
 * on narrowing every report with nothing on screen to explain why.
 */
export const SHOW_PURPOSES = false;
